import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import ButtonLink from "../../components/Button/index.js";

import './index.scss';

import Asset1 from '../../assets/images/Asset1.svg';
import Asset2 from '../../assets/images/Asset2.svg';
import Asset3 from '../../assets/images/Asset3.svg';
import Asset4 from '../../assets/images/Asset4.svg';
import Asset5 from '../../assets/images/Asset5.svg';
import Asset6 from '../../assets/images/Asset6.svg';
import Asset7 from '../../assets/images/Asset7.svg';
import Asset8 from '../../assets/images/Asset8.svg';
import Asset9 from '../../assets/images/Asset9.svg';

function openLink(event) {
    if(event.target.nodeName.toLowerCase() !== 'a') {
       window.open("https://restaurantguru.com");
       return 0;
    }
}
const obfuscateEmail = () => {
    const email = "info" + "@" + "borscht.nl";
    return email;
  };

function Footer() {
  const { t } = useTranslation();
  const { lang } = useParams(); 

  const user = "&#105;&#110;&#102;&#111;";
  const domain = "&#98;&#111;&#114;&#115;&#99;&#104;&#116;&#46;&#110;&#108;";
  return (
        <div className="footer">

            <div className='ornament'>
                <img src={Asset1} alt=""/>
                <img src={Asset2} alt=""/>
                <img src={Asset3} alt=""/>
                <img src={Asset4} alt=""/>
                <img className='desktop' src={Asset5} alt=""/>
                <img className='desktop' src={Asset6} alt=""/>
                <img className='desktop' src={Asset7} alt=""/>
                <img className='desktop' src={Asset8} alt=""/>
                <img className='desktop' src={Asset9} alt=""/>
            </div>

            <div className='line'></div>

            <div className='list'>
                <ButtonLink to={`/${lang}/`} className="btn">
                    <span>{t('main')}</span>
                </ButtonLink>
                <ButtonLink to={`/${lang}/about`} className="btn">
                    <span>{t('about')}</span>
                </ButtonLink>
                <ButtonLink to={`/${lang}/menu`} className="btn">
                    <span>{t('menu')}</span>
                </ButtonLink>
                <ButtonLink to={`/${lang}/banquets`} className="btn">
                    <span>{t('banquets')}</span>
                </ButtonLink>
                <ButtonLink to={`/${lang}/catering`} className="btn">
                    <span>{t('catering')}</span>
                </ButtonLink>
                <ButtonLink to={`/${lang}/contacts`} className="btn">
                    <span>{t('contacts')}</span>
                </ButtonLink>
            </div>

            <div className='line'></div>

            <div className='information-wrapper'>
                <div className='information'>
                    <div className='contact'>
                        <div className='title'>{t('contact-info')}</div>
                        <div className='info'>
                            <div className='right'>
                                <span>Stationsweg 14</span>
                                <span>1815CC</span>
                                <span>{t('alkmaar')}</span>
                            </div>
                            <div className='left'>
                                <span>072 5203013</span>
                                <div id="email"></div>
                                <a href="mailto:&#105;&#110;&#102;&#111;&#64;&#98;&#111;&#114;&#115;&#99;&#104;&#116;&#46;&#110;&#108;">&#105;&#110;&#102;&#111;&#64;&#98;&#111;&#114;&#115;&#99;&#104;&#116;&#46;&#110;&#108;</a>
                                <span>KvK: 78014220</span>
                            </div>
                        </div>
                    </div>
                    <div className='line line-mobile'></div>
                    <div className='stars'>
                        <a href="https://www.ubereats.com/nl-en/store/borscht-oekraiense-gerechten/mwavlG_VT26G5M6mOvpQPQ" target="_blank" rel="noopener noreferrer"  aria-label="Uber Eats"><div className='uber'></div></a>
                        <div className='guru'>
                            <p></p>
                            <center>
                                <div id="rest_circ5"
                                    onClick={(event) => openLink(event)}>
                                <div className="circ_cont">
                                    <div className="circ_img" style={{background: "url('https://awards.infcdn.net/img/star_red.svg') no-repeat center"}}>&nbsp;</div>
                                    <p>
                                        <a href="https://restaurantguru.com" target="_blank" rel="noopener noreferrer" className="circ_top_title">Restaurant Guru 2023</a>
                                        <span className="">Recommended</span>
                                        <a href="https://restaurantguru.com/Borscht-Alkmaar" rel="noopener noreferrer" className="circ_bot_title " target="_blank">Borscht</a>
                                    </p>
                                </div>
                                </div>
                                <p></p>
                            </center>
                            <p></p>
                        </div>
                        <a href="https://www.thuisbezorgd.nl/menu/borscht" target="_blank" rel="noopener noreferrer" aria-label="Thuisbezorgd"><div className='thuisbezorgd'></div></a>
                    </div>
                    <div className='line line-mobile'></div>
                    <div className='timetable'>
                        <div className='title'>{t('opening-hours')}</div>
                        <div className='time'>
                            <span>{t('tue-thu')}</span>
                            <span>{t('fri-sat')}</span>
                            <span>{t('sunday')}</span>
                            <span>{t('monday')}</span>
                        </div>
                    </div>
                </div>
            </div>
                
            <div className='copyright-wrapper'>
                <div className='copyright'>
                    <div className='part part-heart'>
                        <div className='heart'></div>
                        <span>powered by Ukrainians</span>
                    </div>
                    <div className='small-line'></div>
                    <div className='part'>
                        <span>© Copyright 2022 - 2025 Borscht All rights reserved.</span>
                    </div>
                    <div className='part part-icons'>
                        <span>in Borscht we trust</span>
                        <div className='icons'>
                            <a href="https://www.facebook.com/share/1DtL5rPEJQ/?mibextid=LQQJ4d" target="_blank"  aria-label="Facebook"><div className='icon fb'></div></a>
                            <a href="https://www.instagram.com/borscht_nl?igsh=anJkdmFlY3Z4ZXF2&utm_source=qr" target="_blank"  aria-label="Instagram"><div className='icon insta'></div></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;

